/* istanbul ignore file */
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import { STRINGS } from 'config';
import Consultation from 'pages/Consultation';
import { CookiesPolicy } from 'pages/CookiePolicy';
import { DevLogin } from 'pages/DevLogin';
import NotFoundPage from 'pages/NotFoundPage';
import PastConsultations from 'pages/PastConsultations';
import SummaryPage from 'pages/Summary';

const { IS_DEV_OR_TEST_ENV } = STRINGS.ENVIRONMENT;

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Consultation />} />
      <Route path="/past-consultations" element={<PastConsultations />} />
      <Route path="/summary" element={<SummaryPage />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route path="/cookiepolicy" element={<CookiesPolicy />} />
      {IS_DEV_OR_TEST_ENV && <Route path="/dev-login" element={<DevLogin />} />}
    </>,
  ),
);

export const Routes = () => <RouterProvider router={router} />;
